import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { useCallback } from 'react';
import Clipboard from 'react-clipboard.js';
import { useDispatch } from 'react-redux';
import CopyToClipboardSvg from '@gef-ui/components/atoms/SvgIcon/Icons/CopyToClipboard';
import { toastTypes, toastrPositions } from '@gef-ui/components/organisms/Toastr';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { addToast } from '@gef-ui/toastr/actions';
export const CopyToClipboard = ({ clipboardValue, toasrtConfig = {}, className })=>{
    const dispatch = useDispatch();
    const getClipboardText = useCallback(()=>{
        dispatch(addToast({
            message: getLabelMessage('common:copiedToClipboard'),
            position: toastrPositions.TOP_RIGHT,
            closeable: true,
            timeout: 4000,
            type: toastTypes.SUCCESS,
            options: {
                preventDuplicates: false
            },
            ...toasrtConfig
        }));
        return clipboardValue;
    }, [
        clipboardValue,
        dispatch,
        toasrtConfig
    ]);
    return /*#__PURE__*/ React.createElement(Clipboard, {
        component: "a",
        className: cx('Space--around', className),
        "option-text": getClipboardText
    }, /*#__PURE__*/ React.createElement("span", {
        className: "Icon"
    }, /*#__PURE__*/ React.createElement(CopyToClipboardSvg, null)));
};
CopyToClipboard.propTypes = {
    className: PropTypes.string,
    clipboardValue: PropTypes.string.isRequired,
    toasrtConfig: PropTypes.object
};
export default CopyToClipboard;
